/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import { useThemedStyles } from '../hooks';

const BaseCard = ({
  children,
  onPress,
  style,
  contentStyle,
  activeOpacity = 0.8,
  disabled = false,
  elevation = 2,
  ...props
}) => {
  const styles = useThemedStyles((theme) => createStyles(theme, elevation));

  return (
    <TouchableOpacity
      style={[styles.cardContainer, style]}
      activeOpacity={activeOpacity}
      onPress={onPress}
      disabled={disabled}
      {...props}
    >
      <View style={[styles.contentContainer, contentStyle]}>{children}</View>
    </TouchableOpacity>
  );
};

BaseCard.propTypes = {
  children: PropTypes.node.isRequired,
  onPress: PropTypes.func,
  style: PropTypes.object,
  contentStyle: PropTypes.object,
  activeOpacity: PropTypes.number,
  disabled: PropTypes.bool,
  elevation: PropTypes.number,
};

BaseCard.defaultProps = {
  onPress: () => {},
  style: {},
  contentStyle: {},
  activeOpacity: 0.8,
  disabled: false,
  elevation: 2,
};

const createStyles = (theme, elevation) =>
  StyleSheet.create({
    cardContainer: {
      backgroundColor: theme.colors.background,
      borderRadius: 8,
      marginVertical: 4,
      marginHorizontal: 8,
      padding: 16,
      elevation: elevation,
      shadowColor: theme.colors.shadow || '#000',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.1,
      shadowRadius: 3.84,
      borderWidth: 1,
      borderColor: theme.colors.border || theme.colors.backdrop,
    },
    contentContainer: {
      flex: 1,
    },
  });

export default BaseCard;
